import type { SnackbarCloseReason } from '@mui/material/Snackbar'

/** Default auto-dismiss when the user does not close the toast manually. */
export const APP_TOAST_AUTO_HIDE_MS = 5000

/** Only the auto-hide timer may dismiss via Snackbar `onClose` — not click-away or Escape. */
export function shouldDismissAppToastOnSnackbarClose(reason: SnackbarCloseReason): boolean {
  return reason === 'timeout'
}

/** Shared toast/snackbar position: top-right, below AppShell sticky header (85px) + gap. */
export const APP_TOAST_SNACKBAR_ANCHOR = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
}

/**
 * Header ~85px — `top: 100` keeps the snackbar below the bar visually.
 * `zIndex` must sit above AppShell chrome (sidebar 1200, sticky header 1100) so the portal
 * snackbar is not painted underneath the fixed sidebar in the top-right viewport band.
 * Still below MUI modal layer (~1300) so dialogs/backdrops cover toasts while open.
 */
export const APP_TOAST_SNACKBAR_SX = {
  top: 100,
  right: 24,
  zIndex: 1250,
}
